import { Field } from 'components/DocumentDetail/types'
import { FIELD_TYPE } from 'config'
import { DocumentBuilder } from 'entities/DocumentsOcrBuilder'

export default function getOcrBuilderFields(detail: DocumentBuilder): Field[] {
  const { ocrResp, config } = detail
  const fields = (ocrResp.fields || []).map<Field>((item, idx) => {
    const isCheckbox = item.type === FIELD_TYPE.CHECKBOX

    return {
      name: `fields[${idx}].${isCheckbox ? 'checked' : 'text'}`,
      label: item.name,
      // TODO: checkbox
      type: isCheckbox ? 'checkbox' : 'text',
      testid: `fields${idx}`,
      confidence: item.inferConfidence,
      compProps: { disabled: !config[item.name]?.edit },
    }
  })

  const { title } = ocrResp
  if (title) {
    fields.unshift({
      name: 'title.text',
      label: title.name,
      type: 'text',
      testid: `title`,
      confidence: title.inferConfidence,
      compProps: { disabled: !config?.title?.edit },
    })
  }

  return fields
}
